import React from 'react';
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export default withStyles({
  root: {
    marginBottom: "1rem",
    '& .MuiFormLabel-root': {
      zIndex: 9,
    }
  }
  
})(({ error, ...props }) => {
  const hasError = Boolean(error);
  return <TextField
    fullWidth
    error={hasError}
    helperText={error}
    {...props}
  />
});